import React from 'react';
import { GoalTreeContextMenu } from 'shared/components/connected/goal-context-menu';
import { GoalLinkPickerSlotProps } from 'shared/types/goal-link-picker';

export const GoalLinkPicker: React.FC<GoalLinkPickerSlotProps> = ({
  currentSelection,
  onSelect,
  onClose,
  referenceElement,
  onCreateGoal,
}) => (
  <GoalTreeContextMenu
    currentSelection={currentSelection}
    onSelect={onSelect}
    onClose={onClose}
    referenceElement={referenceElement}
    onCreateGoal={onCreateGoal}
    hideNoLifeArea
  />
);
